var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 370,
    viewBox: "0 0 288 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 370,
    transform: "translate(1632 1080)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1632 -1080)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.228,0,0,308.3,289.7,598l6.073-6.112-.047-.043L397,489.022l.043-.039-2.841-2.8-3.314-3.271L289.66,585.776,12.094,308.21l289.832-295.6L393.516,115.18l6.155-6.073Z",
    transform: "translate(1631.512 852)",
    fill: "#040506"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElement);
export default __webpack_public_path__ + "static/media/logo-element.3d0a985c156246a7d94310e58b36f1a9.svg";
export { ForwardRef as ReactComponent };